/** Hub route: all report tabs live here (uses `?tab=`). */
export const REPORT_HUB_SEGMENT = 'reports';

/** Sidebar route segments with dedicated report pages. */
export const REPORT_SEGMENT_CASH_TRANSACTIONS = 'cash-transactions';
export const REPORT_SEGMENT_USERS = 'users';
export const REPORT_SEGMENT_USER_DETAILS = 'user-details';
export const REPORT_SEGMENT_ORDERS = 'orders';
export const REPORT_SEGMENT_PORTFOLIO_ORDERS_DATA = 'portfolio-orders-data';
export const REPORT_SEGMENT_AUM = 'aum';
export const REPORT_SEGMENT_ACCUMULATED_AUM = 'accumulated-aum';
export const REPORT_SEGMENT_PORTFOLIO_DETAILS = 'portfolio-details';
export const REPORT_SEGMENT_PORTFOLIO_TOTALS = 'portfolio-totals';
export const REPORT_SEGMENT_CMA_USERS = 'cma-users';

/** Open to every logged-in admin: served by its own route in AppRoutes, not by Report.tsx, so it is not in the list below. */
export const REPORT_SEGMENT_FEE_CALCULATIONS = 'fee-calculations';

/** Finance's weekly exports: open to every logged-in admin, served like fee calculations. */
export const REPORT_SEGMENT_FINANCE_USERS = 'finance-users';
export const REPORT_SEGMENT_PORTFOLIO_COMPOSITION = 'portfolio-composition';
export const REPORT_SEGMENT_PORTFOLIO_SNAPSHOT = 'portfolio-snapshot';

/** Sidebar shortcuts: one URL per report, no tab bar. */
export const REPORT_SIDEBAR_STANDALONE_SEGMENTS = [
  REPORT_SEGMENT_CASH_TRANSACTIONS,
  REPORT_SEGMENT_USERS,
  REPORT_SEGMENT_USER_DETAILS,
  REPORT_SEGMENT_ORDERS,
  REPORT_SEGMENT_PORTFOLIO_ORDERS_DATA,
  REPORT_SEGMENT_AUM,
  REPORT_SEGMENT_ACCUMULATED_AUM,
  REPORT_SEGMENT_PORTFOLIO_DETAILS,
  REPORT_SEGMENT_PORTFOLIO_TOTALS,
  REPORT_SEGMENT_CMA_USERS,
] as const;

const standaloneSegmentSet = new Set<string>(REPORT_SIDEBAR_STANDALONE_SEGMENTS);

/** URL path segment under `/report/:segment` ↔ `tab` query key on the hub */
export const reportSegmentByTabParam: Record<string, string> = {
  portfolioOrderExecutions: 'orders',
  cash: 'cash-transactions',
  units: 'portfolio-details',
  alpacaOrdersFxRevenue: 'alpaca-orders-fx-revenue',
  alpacaTransfersFxRevenue: 'alpaca-transfers-fx-revenue',
  jadwaOrdersFxRevenue: 'jadwa-orders-fx-revenue',
  jadwaTransfersFxRevenue: 'jadwa-transfers-fx-revenue',
  userIndexFund: 'users',
  alpacaJournal: 'alpaca-journal',
  fee: 'portfolio-totals',
};

export const tabParamByReportSegment: Record<string, string> = Object.fromEntries(
  Object.entries(reportSegmentByTabParam).map(([tab, seg]) => [seg, tab]),
);

export function isReportHubSegment(segment: string | undefined): boolean {
  return segment === REPORT_HUB_SEGMENT;
}

export function isStandaloneSidebarReportSegment(segment: string): boolean {
  return standaloneSegmentSet.has(segment);
}
